/**
 * Only executes a function once, then always returns the cached result.
 *
 * @param func Function to cache return value for
 */
export function memoise<T extends ( ...args: any[] ) => any, U extends ReturnType<T>>( func: T ): () => U {
  return ( ( cache?: U ) => () => ( cache || ( cache = func() ) ) )();
}

/**
 * Get the width of a scrollbar
 */
export const getScrollbarWidth = memoise( () => {
  const textarea = document.createElement( 'textarea' );
  textarea.rows = 1;
  document.body.appendChild( textarea );
  const widthFull = textarea.scrollWidth;
  textarea.value = '\n\n';
  const widthScroll = textarea.scrollWidth;
  document.body.removeChild( textarea );
  return widthFull - widthScroll;
} );
